<script setup lang="ts">
import { computed, inject, ref } from 'vue'
import SplitScreenLayout from './SplitScreenLayout.vue'
import {
  customElementPropsKey,
  FrontendTemplate,
} from '@/types/customElementProps.types'

const templateProps = inject(customElementPropsKey)
const logoPath = ref(`${templateProps?.resourcesPath}/img/sm_logo.svg`)
const isRegistrationPage = computed(
  () => templateProps?.template === FrontendTemplate.REGISTER,
)
const buttonHref = computed(() =>
  isRegistrationPage.value
    ? templateProps?.loginUrl
    : templateProps?.registrationUrl,
)
</script>

<template>
  <v-app>
    <v-app-bar :elevation="1">
      <template #prepend>
        <img :src="logoPath" :height="32" class="ml-4" />
      </template>
      <template #append>
        <div
          class="d-flex align-center gap-4"
          v-if="templateProps?.registrationEnabled"
        >
          <div class="text-body-2">
            {{
              isRegistrationPage
                ? $t('header.auth.label')
                : $t('header.register.label')
            }}
          </div>
          <v-btn
            variant="text"
            color="primary"
            :href="buttonHref"
            data-cy="header-register-button"
          >{{
            isRegistrationPage
              ? $t('header.auth.button')
              : $t('header.register.button')
          }}</v-btn>
        </div>
      </template>
    </v-app-bar>
    <v-main>
      <SplitScreenLayout>
        <slot />
      </SplitScreenLayout>
    </v-main>
  </v-app>
</template>
